import { Children, cloneElement } from 'react';
import PropTypes from 'prop-types';
import classNames from 'clsx';
import css from './customizableDialogView.module.scss';

function Buttons({ className, children }) {
  return (
    <div className={classNames(css.buttons, className)}>
      {Children.map(children, (child) =>
        cloneElement(child, {
          className: classNames(child.props.className, css.button),
        }),
      )}
    </div>
  );
}

Buttons.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Buttons;
